import {
  UPSERT_PACKAGE_INSTALLER,
  UPSERT_PACKAGE_INSTALLER_SUCCESS,
  UPSERT_PACKAGE_INSTALLER_FAIL,
  GET_LIST_PACKAGE_INSTALLER,
  GET_LIST_PACKAGE_INSTALLER_SUCCESS,
  GET_LIST_PACKAGE_INSTALLER_FAIL,
  INACTIVE_PACKAGE_INSTALLER,
  INACTIVE_PACKAGE_INSTALLER_SUCCESS,
  INACTIVE_PACKAGE_INSTALLER_FAIL,
  FILTER_PACKAGE_INSTALLER,
  FILTER_LOADING_PACKAGE_INSTALLER,
  RESET_PACKAGE_INSTALLER_FLAG
} from "./actionTypes"

// Helper function to group installers by fullName and naCode
const groupInstallers = (installers) => {
  if (!installers || !Array.isArray(installers)) return [];
  
  const groupMap = new Map();
  
  installers.forEach(installer => {
    const key = `${installer.naCode}`;
    
    if (!groupMap.has(key)) {
      groupMap.set(key, {
        key: key,
        id: `group_${key}`,
        fullName: installer.fullName,
        naCode: installer.naCode,
        mobileNumber: installer.mobileNumber,
        isGroupHeader: true,
        childCount: 0,
        children: []
      });
    }
    
    const group = groupMap.get(key);
    group.children.push({ ...installer, key: installer.id });
    group.childCount = group.children.length;
  });
  
  // Convert map to array and sort by fullName
  return Array.from(groupMap.values()).sort((a, b) => 
    (a.fullName || '').localeCompare(b.fullName || '', 'fa')
  );
};

const INIT_STATE = {
  lstPackageInstaller: [],
  lstPackageInstallerFiltered: [],
  lstPackageInstallerGrouped: [],
  lstPackageInstallerGroupedFiltered: [],
  error: null,
  success: null,
  loading: false,
  actionName: {},
}

const packageInstallerReducer = (state = INIT_STATE, action) => {
  switch (action.type) {
    case UPSERT_PACKAGE_INSTALLER:
      return {
         ...state, loading: true 
        }
    case UPSERT_PACKAGE_INSTALLER_SUCCESS:
      const { message, updatedData, isNewItem } = action.payload;
      
      if (isNewItem) {
        // Add new item to the list
        const newList = [...state.lstPackageInstaller, updatedData];
        return { 
          ...state, 
          loading: false, 
          success: message,
          lstPackageInstaller: newList,
          lstPackageInstallerFiltered: [],
          lstPackageInstallerGrouped: groupInstallers(newList),
          lstPackageInstallerGroupedFiltered: []
        };
      } else {
        // Update existing item in the list
        const updatedList = state.lstPackageInstaller.map(item =>
          item.id === updatedData.id ? { ...item, ...updatedData } : item
        );
        
        // Also update filtered list if it exists
        const updatedFilteredList = state.lstPackageInstallerFiltered.length > 0
          ? state.lstPackageInstallerFiltered.map(item =>
              item.id === updatedData.id ? { ...item, ...updatedData } : item
            )
          : [];
        
        return { 
          ...state, 
          loading: false, 
          success: message,
          lstPackageInstaller: updatedList,
          lstPackageInstallerFiltered: updatedFilteredList,
          lstPackageInstallerGrouped: groupInstallers(updatedList),
          lstPackageInstallerGroupedFiltered: groupInstallers(updatedFilteredList)
        };
      }
    case UPSERT_PACKAGE_INSTALLER_FAIL:
      return { 
        ...state, 
        loading: false,
        error: action.payload 
      }
    case GET_LIST_PACKAGE_INSTALLER:
      return {
         ...state, 
         loading: true 
        }
    case GET_LIST_PACKAGE_INSTALLER_SUCCESS:
      return { 
        ...state, 
        loading: false, 
        lstPackageInstaller: action.payload,
        lstPackageInstallerFiltered: [],
        lstPackageInstallerGrouped: groupInstallers(action.payload),
        lstPackageInstallerGroupedFiltered: [],
      }
    case GET_LIST_PACKAGE_INSTALLER_FAIL:
      return { 
        ...state, 
        loading: false, 
        error: action.payload 
      }
    case INACTIVE_PACKAGE_INSTALLER:
      return { 
        ...state, 
        loading: true 
      }
    case INACTIVE_PACKAGE_INSTALLER_SUCCESS:
      return { 
        ...state, 
        loading: false, 
        success: action.payload 
      }
    case INACTIVE_PACKAGE_INSTALLER_FAIL:
      return { 
        ...state, 
        loading: false, 
        error: action.payload 
      }
    case FILTER_PACKAGE_INSTALLER: {
        const { fullName, packageCompanyTypeEnum, companyName } = action.payload || {};
        // If no filter, reset
        if (!fullName && !packageCompanyTypeEnum && !companyName) {
          return {
            ...state,
            lstPackageInstallerFiltered: [],
            lstPackageInstallerGroupedFiltered: []
          }
        }
        let filteredList = state.lstPackageInstaller;
        
        // Filter by fullName (contains search)
        if (fullName) {
          filteredList = filteredList.filter(installer =>
            installer.fullName && installer.fullName.toLowerCase().includes(fullName.toLowerCase())
          );
        }
        
        // Filter by packageCompanyTypeEnum (exact match)
        if (packageCompanyTypeEnum) {
          filteredList = filteredList.filter(installer =>
            installer.packageCompanyTypeEnum === packageCompanyTypeEnum
          );
        }
        
        // Filter by companyName (contains search)
        if (companyName) {
          filteredList = filteredList.filter(installer =>
            (installer.companyName && installer.companyName.toLowerCase().includes(companyName.toLowerCase())) ||
            (installer.packageCompanyName && installer.packageCompanyName.toLowerCase().includes(companyName.toLowerCase()))
          );
        }
     
        return { 
          ...state, 
          lstPackageInstallerFiltered: filteredList,
          lstPackageInstallerGroupedFiltered: groupInstallers(filteredList)
        };
    }
    case FILTER_LOADING_PACKAGE_INSTALLER:
      return { ...state, loading: action.payload }
    case RESET_PACKAGE_INSTALLER_FLAG:
      return { ...state, error: null, success: null }
    default:
      return state
  }
}

export default packageInstallerReducer
